<script>
	import { FormatAndRound } from './calculations.js';
    import { _ } from 'svelte-i18n';
    import { selectedMuscleGroups } from './stores/muscleGroupStore';

    
    export let bodypart = "";
    export let calculatedValues = [];

    const ZeroCheck = (value) => {
        if (value == 0 || isNaN(value) || !isFinite(value)) {
            return "";
        }
        else {
            return value;
        }
    }
</script>

<style>

    table {
        margin: var(--spacingLarge) auto var(--spacingXLarge);
        border-spacing: 0;
        min-width: 600px;
    }

    .unemph {
        font-weight: 400;
    }

    .emph {
        font-weight: 800;
    }

    th, td {
        padding: var(--spacingXSmall);
    }

    th {
        padding: var(--spacingSmall);
        border-bottom: 2px solid var(--colorElementOpaque);
    }

    td {
        font-size: var(--typeSizeDefault);
        text-align: center;
        width: 12.5%;
        min-width: 60px;
    }

    .subheader td {
        padding: var(--spacingSmall);
        font-size: var(--typeSizeSmall);
        border: 1px solid white; /* To make the spacer work */
    }

    .first-th {
        text-align: left;
    }

    .result_cells td {
        background-color: var(--colorElementOpaque2);
        border: 1px solid white;
    }

    td.first-col {
        background-color: var(--colorBg);
        font-size: var(--typeSizeDefault);
        font-weight: 400;
        text-align: left;
        min-width: 100px;
    }

    td.first-in-section {
        border-radius: 5px 0 0 5px;
    }

    td.last-in-section {
        border-radius: 0 5px 5px 0;
    }

    td.last-in-table {
        border-radius: 0 5px 5px 0;
    }

    td.spacer {
        width: 9px;
        min-width: 9px;
        max-width: 9px;
        border-width: 0 4px 0 4px;
        border-color: white;
        padding: 0;
        background-color: var(--colorElementOpaque);
    }
</style>

<table>
    <tr>
        <th class="first-th">{$_('calculator.results.muscle')}</th>
        <th colspan="4">{$_('calculator.results.strength')} Nm</th>
        <th colspan="3" class="unemph">{$_('calculator.results.prediction')}</th>
        <th colspan="3">{$_('calculator.results.strength')} %</th>
    </tr>
    <tr class="subheader">
        <td></td>
        <td class="spacer"></td>
        <td class="nm-right">{$_('calculator.results.right')}</td>
        <td class="nm-left">{$_('calculator.results.left')}</td>
        <td class="spacer"></td>
        <td class="pred-strength">{$_('calculator.results.predicted')}</td>
        <td class="pred-lower">{$_('calculator.results.lower')}</td>
        <td class="pred-upper">{$_('calculator.results.upper')}</td>
        <td class="spacer"></td>
        <td class="perc-right">{$_('calculator.results.right')}</td>
        <td class="perc-left">{$_('calculator.results.left')}</td>
    </tr>

    {#each calculatedValues as muscle }
        {#if $selectedMuscleGroups.some(group => group === muscle.id) && muscle.muscleType == bodypart}
            <tr class="result_cells">
                <td class="muscle-name first-col">{$_('calculator.muscles.short.' + muscle.name)}</td>
                <td class="spacer"></td>
                <td class="nm-right first-in-section emph">{FormatAndRound(1, ZeroCheck(muscle.nmRight))}</td>
                <td class="nm-left last-in-section emph">{FormatAndRound(1, ZeroCheck(muscle.nmLeft))}</td>
                <td class="spacer"></td>
                <td class="pred-strength first-in-section">{FormatAndRound(1, ZeroCheck(muscle.predicted))}</td>
                <td class="pred-lower">{FormatAndRound(1, ZeroCheck(muscle.predLower))}</td>
                <td class="pred-upper last-in-section">{FormatAndRound(1, ZeroCheck(muscle.predUpper))}</td>
                <td class="spacer"></td>
                <td class="perc-right first-in-section emph">{FormatAndRound(1, ZeroCheck(muscle.percRight))}</td>
                <td class="perc-left last-in-table emph">{FormatAndRound(1, ZeroCheck(muscle.percLeft))}</td>
            </tr>
        {/if}
    {/each}
</table>

